import { useLeaseCompStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useLeaseCompDelete = (): (id: number) => Promise<void> => {
    const leaseCompStore = useLeaseCompStore();

    return async (id: number): Promise<void> => {
        try {
            await leaseCompStore.deleteLeaseComp(id);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeaseCompDelete;